var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: { kamitaku: "", propsData: { countryMultiple: false } },
            on: { searchChange: _vm.searchChange }
          }),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { filterable: "", placeholder: _vm.$t("userType") },
                  on: { change: _vm.userTypeChange },
                  model: {
                    value: _vm.searchData.is_new_register,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "is_new_register", $$v)
                    },
                    expression: "searchData.is_new_register"
                  }
                },
                _vm._l(_vm.userTypes, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("statisticalContent")
                  },
                  on: { change: _vm.getListnew },
                  model: {
                    value: _vm.StatisticalContentValue,
                    callback: function($$v) {
                      _vm.StatisticalContentValue = $$v
                    },
                    expression: "StatisticalContentValue"
                  }
                },
                _vm._l(_vm.StatisticalContent, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.StatisticalContentValue == "1"
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("calculationMethod")
                      },
                      on: { change: _vm.getListnew },
                      model: {
                        value: _vm.CalculationValue,
                        callback: function($$v) {
                          _vm.CalculationValue = $$v
                        },
                        expression: "CalculationValue"
                      }
                    },
                    _vm._l(_vm.Calculation, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    multiple: "",
                    clearable: "",
                    filterable: "",
                    "collapse-tags": "",
                    placeholder: _vm.$t("filterCondition")
                  },
                  on: { change: _vm.totalDynamicChange },
                  model: {
                    value: _vm.totalDynamicValue,
                    callback: function($$v) {
                      _vm.totalDynamicValue = $$v
                    },
                    expression: "totalDynamicValue"
                  }
                },
                _vm._l(_vm.totalDynamic, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.rawData.game_mark.indexOf("yjfm") == -1
            ? [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("pleaseChoose")
                        },
                        on: { change: _vm.getServer },
                        model: {
                          value: _vm.paramsData.is_prod,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "is_prod", $$v)
                          },
                          expression: "paramsData.is_prod"
                        }
                      },
                      _vm._l(_vm.severlist, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          multiple: "",
                          "collapse-tags": "",
                          clearable: "",
                          filterable: "",
                          placeholder: _vm.$t("pleaseSelectServer")
                        },
                        on: { change: _vm.YjfmSeverChange },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            on: { change: _vm.selectYjfmAll },
                            model: {
                              value: _vm.checked,
                              callback: function($$v) {
                                _vm.checked = $$v
                              },
                              expression: "checked"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("selectAll")))]
                        ),
                        _vm._l(_vm.serverList, function(item) {
                          return _c("el-option", {
                            key: item.serverID,
                            attrs: {
                              label: item.serverName,
                              value: item.serverID
                            }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ]
            : [
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "flex-1",
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("pleaseChoose")
                        },
                        on: { change: _vm.envIdChange },
                        model: {
                          value: _vm.paramsData.env_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "env_id", $$v)
                          },
                          expression: "paramsData.env_id"
                        }
                      },
                      _vm._l(_vm.szgmEnv, function(item) {
                        return _c("el-option", {
                          key: item.label,
                          attrs: { label: item.label, value: item.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: _vm.$t("serverChannel")
                        },
                        on: { change: _vm.serverChange },
                        model: {
                          value: _vm.server_channel,
                          callback: function($$v) {
                            _vm.server_channel = $$v
                          },
                          expression: "server_channel"
                        }
                      },
                      _vm._l(_vm.serverChannel, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          filterable: "",
                          placeholder: _vm.$t("showTestServer")
                        },
                        on: { change: _vm.serverChannelChange },
                        model: {
                          value: _vm.show_test,
                          callback: function($$v) {
                            _vm.show_test = $$v
                          },
                          expression: "show_test"
                        }
                      },
                      _vm._l(_vm.serverType, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 4 } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          multiple: "",
                          "collapse-tags": "",
                          filterable: "",
                          clearable: "",
                          placeholder: _vm.$t("server")
                        },
                        on: { change: _vm.severChange },
                        model: {
                          value: _vm.paramsData.server_id,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "server_id", $$v)
                          },
                          expression: "paramsData.server_id"
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            on: { change: _vm.selectAll },
                            model: {
                              value: _vm.checked,
                              callback: function($$v) {
                                _vm.checked = $$v
                              },
                              expression: "checked"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("selectAll")))]
                        ),
                        _vm._l(_vm.serverListYJ, function(item) {
                          return _c("el-option", {
                            key: item.serverID,
                            attrs: {
                              label: item.serverName,
                              value: item.serverID
                            }
                          })
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("selectDeviceType")
                  },
                  model: {
                    value: _vm.searchData.system_info,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "system_info", $$v)
                    },
                    expression: "searchData.system_info"
                  }
                },
                _vm._l(_vm.devisionList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: !_vm.tableData.length },
                  on: { click: _vm.exportdata }
                },
                [_vm._v(_vm._s(_vm.$t("export")))]
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: { click: _vm.getListnew }
                },
                [_vm._v(_vm._s(_vm.$t("search")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "sticky-table-header",
              rawName: "v-sticky-table-header",
              value: 0,
              expression: "0"
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          ref: "tableRef",
          attrs: { id: "tableRef", data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: {
              sortable: "",
              "class-name": "font-bold",
              prop: "date",
              label: _vm.$t("time"),
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              sortable: "",
              prop: "register_num",
              label: _vm.searchUserType,
              "min-width": "150"
            }
          }),
          _vm._l(_vm.Dynamic, function(item, index) {
            return _c("el-table-column", {
              key: index,
              attrs: {
                prop: item.value,
                label: item.label,
                "min-width": _vm.$utils.flexColumnWidth(item.label, false)
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [_vm._v(" " + _vm._s(row[item.value]) + " ")]
                    }
                  }
                ],
                null,
                true
              )
            })
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }